import { compact } from 'lodash';

import {
   InvalidProcedureFault,
   MainDiagnosisNotSelectedFault,
   VisitFinishApprovedCommand,
   VisitFinishNotApprovedCommand,
} from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { createInterpolatedTranslationKey } from '@dreryk/react-common';
import { dispatchSnackbarNegativeEvent } from '@dreryk/react-components';

import { visitDetailsTranslationKeys } from '../../../../translations';
import { createCommonVisitParameters } from '../../visitForm.utils';
import { VisitFormBean } from '../../visitForm.types';

type VisitCommandConstructor = (new () => VisitFinishApprovedCommand) | (new () => VisitFinishNotApprovedCommand);

type UseVisitCommandOptions = {
   visitId: number;
   onSuccess: VoidFunction;
};

export const useVisitCommand = (
   Command: VisitCommandConstructor,
   options: UseVisitCommandOptions
): UseCqrsCommandResult<void, VisitFormBean, InvalidProcedureFault | MainDiagnosisNotSelectedFault> => {
   return useCqrsCommand<void, VisitFormBean, InvalidProcedureFault | MainDiagnosisNotSelectedFault>(
      (parameters) => {
         const command = new Command();
         command.visitId = options.visitId;
         command.commonVisitParameters = createCommonVisitParameters(parameters);
         return command;
      },
      {
         onSuccess: options.onSuccess,
         onFault: {
            'egabinet-visit-frontend-api:InvalidProcedureFault': ({ code, name }) => {
               dispatchSnackbarNegativeEvent(
                  createInterpolatedTranslationKey(visitDetailsTranslationKeys.invalidProcedure, {
                     procedure: compact([code, name]).join(' '),
                  })
               );
            },
            'egabinet-visit-frontend-api:MainDiagnosisNotSelectedFault': () => {
               dispatchSnackbarNegativeEvent(visitDetailsTranslationKeys.mainDiagnosisNotSelected);
            },
         },
      }
   );
};
